{
  "Users": "Users",
  "confirm-password-generation": "Are you sure you want to generate a new password for {{email}}?",
  "password-error": "A password error occurred:\n{{message}}",
  "generated-password": "Generated password: {{password}}",
  "confirm-status-change": "Are you sure you want to change {{email}}'s status from {{fromStatus}} to {{toStatus}}?",
  "status-error": "A status error occurred:\n{{message}}",
  "impersonate-error": "An error occurred when trying to impersonate",
  "Invite": "Invite",
  "Id": "ID",
  "Email": "Email",
  "Status": "Status",
  "Realm": "Realm",
  "Last active": "Last active",
  "Created": "Created",
  "Has password": "Password",
  "Groups": "Groups",
  "Active from": "Active from",
  "Active to": "Active to",
  "Created from": "Created from",
  "Created to": "Created to",
  "Lacks password": "Password",
  "Password expired": "Password expired",
  "found-users": "Found {{count}} users",
  "User status": "User status",
  "Generate password": "Generate password",
  "Deactivated": "Deactivated",
  "Enter your search parameters above and click \"Search\"": "Enter your search parameters above and click \"Search\"",
  "No users found": "No users found",
  "Impersonate user": "Impersonate user",

  "Title": "Title",
  "Type": "Type",
  "Platform": "Platform",
  "Enrolled": "Enrolled",
  "Started": "Started",
  "Progress": "Progress",
  "Completed": "Completed",
  "Expired": "Expired",

  "Reset E-Learning state": "Reset bookmarked state",
  "Create completion": "Create completion",
  "Void all progress": "Void progress",

  "delete-xapi-state-modal-header": "Reset E-Learning state",
  "delete-xapi-state-modal-message": "This will reset any bookmarked state the user has on this learning on the selected registration, allowing them to start fresh if they get stuck (does not remove progress)",
  "create-completion-modal-header": "Create completion",
  "create-completion-modal-message": "This will create a completion for this learning for the selected registration",
  "void-progress-modal-header": "Void learning progress",
  "void-progress-modal-message": "This will remove any progress the user has on this learning for the selected registration",

  "role": "Role",
  "role-user": "User",
  "role-user-description": "Can access all the content available to their organization",
  "role-admin": "Admin",
  "role-admin-description": "Has full administrative rights to their organization",
  "role-super-admin": "Super Admin",
  "role-super-admin-description": "Has full administrative rights to all organizations",
  "change-role-header": "Change role"
}
